import { useMemo } from 'react'

export default function useContentfulPage({
  sections,
  metaTitle,
  metaDescription,
  metaImage,
}) {
  return useMemo(() => {
    // sections
    const sectionsByCompoonentId = sections.reduce((acc, obj) => {
      acc[obj?.componentId?.trim()] = obj
      return acc
    }, {})

    return {
      ...sectionsByCompoonentId,
      meta: {
        title: metaTitle,
        description: metaDescription,
        image: metaImage,
      },
    }
  }, [sections, metaTitle, metaDescription, metaImage])
}
